function RoundToTwoDecimalPlaces(value) {
    // Round the value to two decimal places
    const roundedValue = Math.round(value * 100) / 100;
  
    return roundedValue;
}
  
export default RoundToTwoDecimalPlaces;
  